import View from "./View"

const MultiCalDarkSVG = require("./MulticalDark.svg")

const content = { View, MultiCalDarkSVG }
export default content
